import { Modal, notification } from "antd";
import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { bannersStore } from "../content/banner/BannersStore";

export class UserActivityStore {
  loading = false;
  visible = false;
  id?: string;
  category?: string;

  data: any = null;

  constructor() {
    makeAutoObservable(this, {});
  }

  @action
  showDetail(it) {
    this.id = it.id;
    this.category = it.category;
    this.visible = true;
    this.loading = true;

    Api.userActivities
      .psDetails(it.category, it.id)
      .then((res) => {
        runInAction(() => {
          console.log(res, res.data);
          this.data = res.data.userActivity;
        });
      })
      .finally(() =>
        runInAction(() => {
          this.loading = false;
        })
      );
  }

  @action
  close() {
    this.visible = false;
  }

  @action refresh() {
    return this.showDetail({ id: this.id, category: this.category });
  }

  @action delBanner(banner) {
    Modal.confirm({
      title: "Are you sure to delete?",
      onOk: () => {
        return Api.banner.delBanner(banner.id).then(() => {
          notification.success({
            message: "Deleted",
          });
          bannersStore.refresh();
          return this.refresh();
        });
      },
    });
  }
}

export const userActivityStore = new UserActivityStore();
